if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        // Initialize gold text on page load
        this.initializeGoldText();

        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      initializeGoldText() {
        // Check all option containers for initial gold text display
        const optionContainers = this.querySelectorAll('.product-form__input');
        optionContainers.forEach((container) => {
          const selectedValue = container.querySelector('[data-selected-swatch-value]');
          if (selectedValue) {
            const currentValue = selectedValue.textContent.trim();
            this.updateGoldText(container, currentValue);
          } else {
            // For dropdowns, check the selected option
            const select = container.querySelector('select');
            if (select && select.selectedOptions.length) {
              const selectedValue = select.selectedOptions[0].value;
              this.updateGoldText(container, selectedValue);
            }
          }
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );

          // Update gold text for dropdown
          this.updateGoldText(target.closest('.product-form__input'), value);
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const optionContainer = target.closest(`.product-form__input`);
          const selectedSwatchValue = optionContainer.querySelector('[data-selected-value]');
          const goldTextElement = optionContainer.querySelector('[data-gold-text]');
          
          // Update variant name first
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
          
          // Update gold text synchronously right after variant name update
          if (goldTextElement) {
            const isGold = value && value.toLowerCase().includes('gold');
            goldTextElement.style.display = isGold ? '' : 'none';
          }
        }
      }

      updateGoldText(optionContainer, variantValue) {
        if (!optionContainer) return;
        
        const goldTextElement = optionContainer.querySelector('[data-gold-text]');
        if (!goldTextElement) return;

        // Check if variant value contains "gold" (case-insensitive)
        if (variantValue && variantValue.toLowerCase().includes('gold')) {
          goldTextElement.style.display = '';
        } else {
          goldTextElement.style.display = 'none';
        }
      }
    }
  );
}
